export const version = '1.1.0.0-fe7784f54';
